import { render, staticRenderFns } from "./QuickAppChildProtectionPolicy.vue?vue&type=template&id=b7f292e6&scoped=true"
import script from "./QuickAppChildProtectionPolicy.vue?vue&type=script&lang=js"
export * from "./QuickAppChildProtectionPolicy.vue?vue&type=script&lang=js"
import style0 from "./QuickAppChildProtectionPolicy.vue?vue&type=style&index=0&id=b7f292e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f292e6",
  null
  
)

export default component.exports